var React = require('react');

function DotCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 3.5C9.091 3.5 3.5 9.092 3.5 16c0 6.909 5.592 12.5 12.5 12.5 6.909 0 12.5-5.592 12.5-12.5 0-6.909-5.592-12.5-12.5-12.5zm0-3C24.56.5 31.5 7.44 31.5 16S24.56 31.5 16 31.5.5 24.56.5 16 7.44.5 16 .5zM16 11a5 5 0 1 1-.001 10.001A5 5 0 0 1 16 11z"}));
}

DotCircle.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = DotCircle;

DotCircle.default = DotCircle;
